import React from "react";
import Hero from "../common/Hero";
import Footer from "../common/Footer";
import MobileBottomBar from "../common/MobileBottomBar";

const FrontPageLayout = ({ children }) => {
    return (
        <>
            <div className="flex flex-col">
                <MobileBottomBar />
                <Hero />
                <main className="flex-1 z-10">{children}</main>
                <Footer />
            </div>
        </>
    );
};

export default FrontPageLayout;
